import { IntegrationKinds } from '@recruitee/integrations-types';
import { createSingleEntityStore } from '@recruitee/ngrx';

const { actions, namespace, reducer, selectors } = createSingleEntityStore<IntegrationKinds[]>()(
  'enabled-integration-kinds',
);

// const EnabledIntegrationKindsActions: Pick<
//   typeof actions,
//   'fetch' | 'fetchSuccess' | 'fetchFailed'
// > = actions;

export {
  actions as EnabledIntegrationKindsActions,
  namespace as EnabledIntegrationKindsNamespace,
  reducer as EnabledIntegrationKindsReducer,
  selectors as EnabledIntegrationKindsSelectors,
};
